import { useLocation, Navigate, Outlet } from "react-router-dom"


const RequireAuth = ({isLoggedin}) => {
    const location = useLocation()

    return (
        isLoggedin
            ? <Outlet />
            : <Navigate to="/" state={{ from: location }} replace />
    )
}
export default RequireAuth